import { render } from "./TungstenNetworkAction.vue?vue&type=template&id=a1a2abac&scoped=true"
import script from "./TungstenNetworkAction.vue?vue&type=script&lang=js"
export * from "./TungstenNetworkAction.vue?vue&type=script&lang=js"

import "./TungstenNetworkAction.vue?vue&type=style&index=0&id=a1a2abac&scoped=true&lang=less"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1a2abac"]])

export default __exports__